import React, { useEffect, useState } from 'react';
import { trackClick } from 'js/utils/trackClick';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';
import routes from 'sitewide-js/core_pre_webpack/routes';

import { CommonUnibrow } from './common';

export default function AddSecondaryPaymentUnibrow() {
  const [show, setShow] = useState(true);

  const nagName = 'AddSecondaryPaymentUnibrow';

  useEffect(() => {
    recordShow(nagName);
  }, []);

  const clickThrough = () => {
    recordClickthrough(nagName);
    trackClick({
      source: 'add_secondary_payment_unibrow',
      extra: {},
    });

    window.location.href = routes.settings_path({
      anchor: 'premium-subscription',
      feature: 'add_secondary_payment_unibrow',
      trigger: 'unibrow',
    });
  };

  const hide = () => {
    recordDismissal(nagName);
    setShow(false);
  };

  if (!show) return null;

  return (
    <CommonUnibrow
      variant="info"
      ctaText="Please add a secondary payment method to prevent interruption of your subscription."
      buttonText="Add Payment Method"
      clickThrough={clickThrough}
      hide={hide}
    />
  );
}
